// extracted by mini-css-extract-plugin
export default {"node-preview":"style_node-preview__uaG8z"};